export default class FiltersFormBar {
    form: HTMLFormElement;

    constructor() {
        this.form = document.getElementById("filters-form-bar")! as HTMLFormElement;
    }

    submit() {
        this.form.submit()
    }

    getFilters(selector: string): NodeListOf<HTMLElement> {
        return this.form.querySelectorAll(selector);
    }
}
